module.exports = __webpack_public_path__ + "static/media/airbnbadd.5ef8b7e4.svg";